// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"WM-z","carouselContainer":"XM-z"};